export * from "./ProductConfiguratorComponent";
